import React from "react";
import Form from "react-bootstrap/Form";
import SectionHeader from "./SectionHeader";

function EventCreateFormStep6({
  layouts,
  layoutsStatus,
  selectedDivisions,
  setSelectedDivisions,
}) {
  const handleLayoutChange = (e) => {
    const newLayoutId = parseInt(e.target.value, 10);

    // Update all divisions to use the same layout
    const newSelectedDivisions = selectedDivisions.map((division) => ({
      ...division,
      layout_id: newLayoutId,
    }));

    setSelectedDivisions(newSelectedDivisions);
  };

  // Get the current layout_id (should be the same for all divisions)
  const currentLayoutId =
    selectedDivisions.length > 0 ? selectedDivisions[0].layout_id : 1;

  return (
    <>
      <SectionHeader
        title={"Layout"}
        subtitle={"Choose one layout that applies to all divisions"}
        size={1}
        spaced={true}
        className="text-center mt-3 mb-3"
      />

      {layoutsStatus === "loading" && <div>Loading Layouts...</div>}

      {layouts && selectedDivisions && (
        <div className="mb-4">
          <Form.Group className="mb-3">
            <Form.Label className="h5">
              Select Layout for All Divisions:
            </Form.Label>
            <Form.Control
              as="select"
              onChange={handleLayoutChange}
              value={currentLayoutId}
              style={{
                padding: "8px 12px",
                lineHeight: "1.5",
                minHeight: "38px",
                fontSize: "16px",
              }}
            >
              {layouts.map((layout, index) => (
                <option
                  key={index}
                  value={layout.layout_id}
                  style={{ padding: "8px" }}
                >
                  {layout.courses.course_name} ({layout.layout_name})
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <div className="alert alert-info">
            <strong>Selected Divisions:</strong>{" "}
            {selectedDivisions.map((d) => d.division_name).join(", ")}
            <br />
            <small>
              This layout will be applied to all selected divisions.
            </small>
          </div>
        </div>
      )}
    </>
  );
}

export default EventCreateFormStep6;
